import React, { Component } from 'react';
import { Grid, Dropdown, Segment, Form, Button, Header, Divider, Accordion, Icon, Table } from 'semantic-ui-react';
import VirtualizedSelect from 'react-virtualized-select';
import 'react-select/dist/react-select.css';
import '../../../css/virtual-select.css';
import { getUserInfo, createOrUpdateUser, getNotifications, getLoginProviders } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { NotificationManager } from 'react-notifications';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
const initialState = {
    usrId: 0,
    usrUserName: "",
    usrPassword: "",
    usrFirstName: "",
    usrLastName: "",
    usrEmail: "",
    usrTitle: "",
    usrPhone: "",
    usrLocked: "N",
    usrInternal: "N",
    usrMailAdmin: "N",
    usrActive: "Y",
    usrInternalMailAccess: "N",
    usrEnterInterest: "N",
    usrAccessClients: [],
    usrPermissions: [],
    userNotificationReportsMapping: [],
    usrLoginProvider: 0
}
const defaultIdentity = {
    corporateId: 0,
    templateId: 0,
    templateName: 'Internal'
}
class AddUser extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            loading: true,
            activeIndex: -1,
            corporate: [],
            clients: [],
            usrClients: [],
            initialState: initialState,
            user: initialState,
            errorMessage: [],
            notifications: [],
            loginIdentityManager: [defaultIdentity],
            loginIdentityManagerByUser: [defaultIdentity],
            open: false
        };

    }

    componentDidMount() {
        
        getNotifications(this.props.params.id).then(response => {
            let reports = [];
            response.forEach(report => {
               let item = {
                   value: report.unrId,
                   label: report.unrReportName,
                   unrId: report.unrId,
                   disabled: report.restrictedReportByUser
                }
                reports.push(item);
            });
            this.setState({
                notifications: reports
            });
        });

        getLoginProviders().then(response => {
            this.setState({ loginIdentityManager: response}, () => this.getUserDetail())
        })
    }

    getUserDetail(){
        if (this.props.params.id > 0) {
            this.props.addItem("helpFile", "admin_user-edit.md");
            getUserInfo(this.props.params.id).then(response => {
                let corporate = [];
                let usrClients = [];
                if (response !== null) {

                    let providers = this.state.loginIdentityManagerByUser

                    if (response.usrInternal !== 'Y') {
                        if (response.usrAccessClients && response.usrAccessClients.length > 0) {
                            response.usrAccessClients.forEach(accessClient => {
                                corporate.push(accessClient.uscCrpRefId);
                                accessClient.uscCltRefId.forEach(client => {
                                    usrClients.push(client);
                                })
                            });
                        }

                        let matchedProviders = this.state.loginIdentityManager.filter(l => corporate.includes(l.corporateId));
                        matchedProviders = matchedProviders.reduce(
                            (unique, item) => (unique.filter(u => u.templateId == item.templateId).length > 0 ? unique : [...unique, item]),
                            [],
                        );
                        providers.push.apply(providers, matchedProviders);
                    }

                    response.userNotificationReportsMapping.forEach(map => {
                        map['value'] = map.unrId;
                        map['label'] = map.unrReportname;  
                    });

                    this.setState({
                        loginIdentityManagerByUser: providers,
                        user: response,
                        corporate: corporate,
                        usrClients: usrClients,
                        loading: false,
                        initialState: response
                    }, () => {
                        this.afterSetStateFinished();
                    });
                }
            });
        } else {
            this.props.addItem("helpFile", "admin_add-user.md");
            this.setState({
                loading: false
            });
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    afterSetStateFinished() {
        this.resetClients(this.props.items.corporate.filter(crp => {
            return this.state.corporate.indexOf(crp.key) > -1;
        }));
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
        this.setState({ activeIndex: newIndex })
    }

    handleChange = (e) => {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        })

    }

    handleCheckbox = (e, { name, checked }) => {

        this.setState({
            user: {
                ...this.state.user,
                [name]: (checked) ? "Y" : "N"
            }
        });
    }

    handleAgencyInternal = (e, { name, checked }) => {

        let userProvider = this.state.user.usrLoginProvider
        let userProviderList = this.state.loginIdentityManagerByUser

        if (checked) {
            userProvider = defaultIdentity.templateId
            userProviderList = [defaultIdentity]
        }

        this.setState({
            loginIdentityManagerByUser: userProviderList,
            user: {
                ...this.state.user,
                usrLoginProvider: userProvider,
                [name]: (checked) ? "Y" : "N"
            }
        });
    }

    reset = (e) => {
        e.preventDefault();
        this.setState({
            user: this.state.initialState
        });
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    resetClients = (e) => {
        if (e !== null) {
            let clients = [];
            if (e instanceof Array) {
                e.forEach(client => {
                    client.clients.forEach(item => {
                        item["parent"] = client.key;
                        clients.push(item);
                    });
                });
            }

            let providers = this.getProvidersBySelection(e)

            let selectedProvider = this.state.user.usrLoginProvider

            if(providers.filter(p => p.templateId == selectedProvider).length == 0){
                selectedProvider = defaultIdentity.templateId
            }

            this.setState({
                corporate: e,
                clients: clients,
                loginIdentityManagerByUser: providers,
                user: {
                    ...this.state.user,
                    usrLoginProvider: selectedProvider
                }
            });
        }
        this.removeAssociatedClientsOnCorporateRemoved(e);
    };

    getProvidersBySelection = (e) => {
        let providers = [defaultIdentity]
            if (e instanceof Array) {
                let matchedProviders = this.state.loginIdentityManager.filter(l => e.filter(clt => l.corporateId == clt.key).length > 0 ? true : false);
                matchedProviders = matchedProviders.reduce(
                    (unique, item) => (unique.filter(u => u.templateId == item.templateId).length > 0 ? unique : [...unique, item]),
                    [],
                  );
                providers.push.apply(providers, matchedProviders);
         }

        return providers;
    }

    resetNotification = (e) => {

        this.setState({
            user: {
                ...this.state.user,
                userNotificationReportsMapping: e
            }
        });
    };

    resetTemplate = (e) => {
        this.setState({
            user: {
                ...this.state.user,
                usrLoginProvider: e.value
            }
        })
    }

    removeAssociatedClientsOnCorporateRemoved = (e) => {
        let removedClients = [];
        let removedCorporate = this.state.corporate.map((i) => {
            return i.key;
        }).filter(x => !e.map((i) => {
            return i.key;
        }).includes(x));

        //get the auth user client list associated with corporate
        this.props.items.corporate.forEach((i) => {
            if (removedCorporate.indexOf(i.key) > -1) {
                removedClients = i.clients;
            }
        });
        //remove the client list
        // eslint-disable-next-line
        this.state.user.usrAccessClients.map((crp) => {
            removedClients.forEach((r) => {
                let cGetIndex = crp.uscCltRefId.indexOf(r.id);
                if (cGetIndex > -1) {
                    crp.uscCltRefId.splice(cGetIndex, 1);
                }
            });
        });
        
    }

    setClients = (e) => {
        if (e !== null) {
            this.setState({
                usrClients: e
            }, () => {
                if (e instanceof Array) {
                    let usrAccessClients = this.state.user.usrAccessClients;
                    let uscCorpClient = {};
                    let removeClients = [];
                    if (e.length === 0) {
                        //get auth user client ids and remove the client from modifying userAccessClient list
                        removeClients = this.state.clients.map((i) => {
                            return i.id;
                        });

                    } else {
                        //removeClients = availableClients.filter(x => !selectedClients.includes(x));
                        removeClients = this.state.clients.map((i) => {
                            return i.id;
                        }).concat(e.map((i) => {
                            return i.key;
                        }));
                    }
                    //remove the selected client from userAccessClients and re-add in below fucntion         
                    // eslint-disable-next-line   
                    removeClients = Array.from(new Set(removeClients));
                    usrAccessClients = usrAccessClients.map((crp) => {
                        let obj = crp;
                        removeClients.forEach(function (val) {
                            let cGetIndex = crp.uscCltRefId.slice().indexOf(val);
                            if (cGetIndex >= 0) {
                                crp.uscCltRefId.splice(cGetIndex, 1);
                            }
                            obj = crp;
                        })
                        return obj;
                    });
                    e.forEach(item => {
                        let corporateExits = false;
                        usrAccessClients = usrAccessClients.map((u) => {
                            // eslint-disable-next-line   
                            if (u.uscCrpRefId === parseInt(item.parent)) {
                                u.uscCltRefId = u.uscCltRefId.slice().concat(item.key);
                                corporateExits = true;
                            }
                            return u;
                        });
                        if (!corporateExits) {
                            if (uscCorpClient[item.parent] === undefined) {
                                uscCorpClient[item.parent] = [];
                            }
                            uscCorpClient[item.parent].push(item.key);
                            usrAccessClients.push({
                                uscCrpRefId: item.parent,
                                uscCltRefId: [item.key]
                            })
                        }
                    });

                    //update the userAccessClients State                    
                    this.setState({
                        user: {
                            ...this.state.user,
                            usrAccessClients: usrAccessClients.filter((crp) => {
                                if (crp !== undefined) {
                                    return crp.uscCltRefId.length > 0
                                } else {
                                    return false;
                                }
                            })
                        }
                    })
                }
            });
        }
    }

    updateAllPermission = (e, data) => {
        let menus = this.props.items.menuItems;
        let existingUserPermissions = this.state.user.usrPermissions;
        let selectedParentChildMenus = [];
        let unknownUserMenus = [];
        menus.map((menu) => {
            if (menu.id === data.name) {
                menu.child.map((list) => {
                    unknownUserMenus.push(list.id);
                    selectedParentChildMenus.push({
                        menuId: list.id,
                        menuPermission: list.permission.map((perm) => {
                            return perm.id
                        })
                    })
                    if(menu.parent == "Reports" && (list.menu == "Acknowledgement" || list.menu == "Cancellation" || list.menu == "Trust")){

                        let selectedOptions = this.state.user.userNotificationReportsMapping;
                        let allOptions = this.state.notifications;
                        if(data.value == 0){
                            this.state.user.userNotificationReportsMapping.forEach(map => {
                                if(map.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                    delete selectedOptions[selectedOptions.indexOf(map)];
                                }
                            });
                            allOptions.forEach(option => {
                                if(option.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                    option['disabled'] = true;
                                }
                            })
                            this.setState({
                                user: {
                                    ...this.state.user,
                                    userNotificationReportsMapping: selectedOptions
                                },
                                notifications : allOptions
                            });
                        }else if(data.value == 1){
                            allOptions.forEach(option => {
                                if(option.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                    option['disabled'] = false;
                                }
                            });
                            this.setState({
                                notifications : allOptions
                            });
                        }
                    }
                    return list;
                });
            }
            return menu;
        });
        // eslint-disable-next-line
        unknownUserMenus.map((menuId) => {
            let match = 0;
            existingUserPermissions.forEach((eup) => {
                if (eup.uspMnuRefId === menuId) {
                    match = 1;
                }
            });
            if (!match) {
                existingUserPermissions.push({
                    uspMnuRefId: menuId,
                    uspPermissions: 0
                });
            }
        });
        let usrPermissions = existingUserPermissions.map((permission) => {
            selectedParentChildMenus.forEach((menu) => {
                if (menu.menuId === permission.uspMnuRefId) {
                    permission.uspPermissions = menu.menuPermission.includes(data.value) ? data.value : 1
                }
            });
            return permission;
        });

        this.setState({
            user: {
                ...this.state.user,
                usrPermissions: usrPermissions
            }
        });
    }

    updatePermission = (e, data) => {
        let usrPermissions = [];
        // eslint-disable-next-line
        usrPermissions = this.state.user.usrPermissions.filter(list => {
            if (list.uspMnuRefId !== data.name) {
                return list;
            }
        });

        usrPermissions.push({
            uspMnuRefId: data.name, uspPermissions: data.value
        });

        let menus = this.props.items.menuItems;
        menus.map((menu) => {
            if (menu.parent == "Reports") {

                menu.child.map((list) => {
                    if(data.name == list.id){
                        if(list.menu == "Acknowledgement" || list.menu == "Cancellation" || list.menu == "Trust"){

                            let selectedOptions = this.state.user.userNotificationReportsMapping;
                            let allOptions = this.state.notifications;
                            if(data.value == 0){
                                this.state.user.userNotificationReportsMapping.forEach(map => {
                                    if(map.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                        delete selectedOptions[selectedOptions.indexOf(map)];
                                    }
                                });
                                allOptions.forEach(option => {
                                    if(option.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                        option['disabled'] = true;
                                    }
                                })
                                this.setState({
                                    user: {
                                        ...this.state.user,
                                        userNotificationReportsMapping: selectedOptions
                                    },
                                    notifications : allOptions
                                });
                            }else if(data.value == 1){
                                allOptions.forEach(option => {
                                    if(option.label.indexOf(list.menu.split(" ")[0]) >= 0){
                                        option['disabled'] = false;
                                    }
                                });
                                this.setState({
                                    notifications : allOptions
                                });
                            }
                        }
                    }
                })
            }
        });

        this.setState({
            user: {
                ...this.state.user,
                usrPermissions: usrPermissions
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.user.usrInternal === "Y") {
            this.validator.fields.Corporate = true;
            this.validator.fields.Client = true;
        }
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            });
            createOrUpdateUser(this.state.user).then(response => {
                if (response !== null) {
                    NotificationManager.success('Success', 'Updated successfully.');
                }
                this.setState({
                    loading: false
                }, () => { this.props.history.push("/users") });
            }).catch((error) => {
                this.setState({
                    loading: false
                });
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            })
            this.forceUpdate();
        }

    }

    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        const { activeIndex } = this.state
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "Users", url: "/users" }, { name: this.props.params.id > 0 ? "Edit User" : "Add User", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                {
                                    (() => {
                                        if (this.props.items.isInternalUser) {
                                            return (
                                                <Form.Group>
                                                    <Form.Field width={3} style={{ marginLeft: "10px" }}>
                                                        <label>&nbsp;</label>
                                                        <Form.Checkbox label={<label><strong>Agency Internal</strong></label>} checked={this.state.user.usrInternal === 'Y' ? true : false} name="usrInternal" onChange={this.handleAgencyInternal} />
                                                    </Form.Field>
                                                    <Form.Field width={6}>
                                                        <label>Select Corporate(s)</label>
                                                        <VirtualizedSelect fluid
                                                            autosize={false}
                                                            onChange={this.resetClients} multi={true}
                                                            value={this.state.user.usrInternal === 'Y' ? [] : this.state.corporate} placeholder={this.state.user.usrInternal === 'Y' ? 'All Corporate(s)' : 'Select Corporate(s)'}
                                                            options={this.props.items.corporate}
                                                            disabled={this.state.user.usrInternal === 'Y' ? true : false}>
                                                        </VirtualizedSelect>
                                                        {this.validator.message('Corporate', this.state.corporate, 'required')}
                                                    </Form.Field>
                                                    <Form.Field width={6}>
                                                        <label>Select Client(s)</label>
                                                        <VirtualizedSelect
                                                            autosize={false}
                                                            placeholder={this.state.user.usrInternal === 'Y' ? 'All Clients(s)' : 'Select Clients(s)'} multi={true}
                                                            onChange={this.setClients}
                                                            value={this.state.user.usrInternal === 'Y' ? [] : this.state.usrClients}
                                                            options={this.state.clients.map(client => ({
                                                                key: client.id,
                                                                value: client.id,
                                                                label: client.name,
                                                                parent: client.parent
                                                            }))}
                                                            disabled={this.state.user.usrInternal === 'Y' ? true : false}>
                                                        </VirtualizedSelect>
                                                        {this.validator.message('Client', this.state.usrClients, 'required')}
                                                    </Form.Field>
                                                </Form.Group>
                                            )
                                        } else {
                                            return (
                                                <Form.Group>
                                                    <Form.Field width={6}>
                                                        <label>Select Corporate(s)</label>
                                                        <VirtualizedSelect fluid
                                                            autosize={false}
                                                            onChange={this.resetClients} multi={true}
                                                            value={this.state.user.usrInternal === 'Y' ? [] : this.state.corporate} placeholder={this.state.user.usrInternal === 'Y' ? 'All Corporate(s)' : 'Select Corporate(s)'}
                                                            options={this.props.items.corporate}
                                                            disabled={this.state.user.usrInternal === 'Y' ? true : false}>
                                                        </VirtualizedSelect>
                                                        {this.validator.message('Corporate', this.state.corporate, 'required')}
                                                    </Form.Field>
                                                    <Form.Field width={6}>
                                                        <label>Select Client(s)</label>
                                                        <VirtualizedSelect
                                                            autosize={false}
                                                            placeholder={this.state.user.usrInternal === 'Y' ? 'All Clients(s)' : 'Select Clients(s)'} multi={true}
                                                            onChange={this.setClients}
                                                            value={this.state.user.usrInternal === 'Y' ? [] : this.state.usrClients}
                                                            options={this.state.clients.map(client => ({
                                                                key: client.id,
                                                                value: client.id,
                                                                label: client.name,
                                                                parent: client.parent
                                                            }))}
                                                            disabled={this.state.user.usrInternal === 'Y' ? true : false}>
                                                        </VirtualizedSelect>
                                                        {this.validator.message('Client', this.state.corporate, 'required')}
                                                    </Form.Field>
                                                </Form.Group>
                                            )
                                        }
                                    }
                                    )()
                                }

                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">User Details</Header>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={4} className="required">
                                                <label>{this.props.t("firstname")}:</label>
                                                <Form.Input placeholder='First Name' required={true} value={this.state.user.usrFirstName || ''} name="usrFirstName" onChange={this.handleChange} />
                                                {/**********   This is where the magic happens     ***********/}
                                                {this.validator.message('First Name', this.state.user.usrFirstName, 'required')}
                                            </Form.Field>
                                            <Form.Field width={4} className="required">
                                                <label>{this.props.t("lastname")}:</label>
                                                <Form.Input placeholder='Last Name' value={this.state.user.usrLastName || ''} name="usrLastName" onChange={this.handleChange} />
                                                {this.validator.message('Last Name', this.state.user.usrLastName, 'required')}
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>Title:</label>
                                                <Form.Input placeholder='Title' value={this.state.user.usrTitle || ''} name="usrTitle" onChange={this.handleChange} maxLength="250" />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <label>Phone:</label>
                                                <Form.Input placeholder='Phone' value={this.state.user.usrPhone || ''} name="usrPhone" onChange={this.handleChange} maxLength="15" />
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">Password & Credentials </Header>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={4} className="required">
                                                <label>Login ID (Email):</label>
                                                <Form.Input placeholder='Email' value={this.state.user.usrUserName || ''} name="usrUserName" onChange={this.handleChange} />
                                                {this.validator.message('Email', this.state.user.usrUserName, 'email')}
                                            </Form.Field>
                                            {
                                                (() => {
                                                    if (!this.props.params.id) {
                                                        return (

                                                            <Form.Field width={4}>
                                                                <label>Password:</label>
                                                                <Form.Input placeholder='Password' type="password" value={this.state.user.usrPassword || ''} name="usrPassword" onChange={this.handleChange} />
                                                            </Form.Field>
                                                        )
                                                    }
                                                })()
                                            }
                                            {/*<Form.Field width={4}>
                                                <label>Confirm Password:</label>
                                                <Form.Input placeholder='Confirm Password' type="password" />
                                            </Form.Field>*/}
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">Permission's</Header>
                                        <Divider></Divider>
                                        <Accordion fluid styled exclusive={true}>
                                            {
                                                // eslint-disable-next-line
                                                this.props.items.menuItems.map((item, itemIndex) => {
                                                    if (item.parent !== "Others") {
                                                        return (
                                                            <div key={itemIndex}>
                                                                <Accordion.Title index={itemIndex} onClick={this.handleClick}>
                                                                    <Icon name='dropdown' />
                                                                    {item.parent}
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                                </Accordion.Title>
                                                                <Accordion.Content active={activeIndex === itemIndex}>
                                                                    <Table>
                                                                        <Table.Header>
                                                                            <Table.Row>
                                                                                <Table.HeaderCell width={2} colSpan={2} textAlign="right">
                                                                                    <Dropdown key={item.id} selection options={[{ id: 0, name: "No access" }, { id: 1, name: "Can view" }, { id: 15, name: "Can view and edit" }].map(p => ({
                                                                                        key: p.id,
                                                                                        value: p.id,
                                                                                        text: p.name
                                                                                    }))} name={item.id} onChange={this.updateAllPermission} placeholder="Permission's" />
                                                                                </Table.HeaderCell>
                                                                            </Table.Row>
                                                                            {item.child.map((c, cIndex) => {
                                                                                let perm = 0;
                                                                                return (
                                                                                    <Table.Row key={cIndex}>
                                                                                        <Table.HeaderCell>{c.menu}</Table.HeaderCell>
                                                                                        <Table.HeaderCell width={2}>
                                                                                            {this.state.user.usrPermissions && this.state.user.usrPermissions.forEach(item => {
                                                                                                if (item.uspMnuRefId === c.id) {
                                                                                                    perm = item.uspPermissions
                                                                                                }
                                                                                            })
                                                                                            }
                                                                                            <Dropdown key={c.id} selection options={c.permission.map(p => ({
                                                                                                key: p.id,
                                                                                                value: p.id,
                                                                                                text: p.name
                                                                                            }))} value={perm} placeholder="Permission's" name={c.id} onChange={this.updatePermission} />
                                                                                        </Table.HeaderCell>
                                                                                    </Table.Row>
                                                                                );
                                                                            })
                                                                            }
                                                                        </Table.Header>
                                                                    </Table>
                                                                </Accordion.Content>
                                                            </div>
                                                        );
                                                    }
                                                })

                                            }
                                        </Accordion>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group>
                                    <Segment>
                                        <Header as="h4">Addition User Rights</Header>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Internal User Mail Access" checked={this.state.user.usrInternalMailAccess === "Y" ? true : false} name="usrInternalMailAccess" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Enter New Acct => Int Rate" checked={this.state.user.usrEnterInterest === 'Y' ? true : false} name="usrEnterInterest" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Mail Admin" checked={this.state.user.usrMailAdmin === 'Y' ? true : false} name="usrMailAdmin" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Lock Status (Is User Locked Out?)" checked={this.state.user.usrLocked === 'Y' ? true : false} name="usrLocked" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                            <Form.Field width={4}>
                                                <Form.Checkbox label="Active Status (Is User Active?)" checked={this.state.user.usrActive === 'Y' ? true : false} name="usrActive" onChange={this.handleCheckbox} />
                                            </Form.Field>
                                        </Form.Group>
                                        <Divider></Divider>
                                        <Form.Group>
                                            <Form.Field width={6}>
                                                <label>Select Notification(s)</label>
                                                <VirtualizedSelect fluid
                                                    autosize={false}
                                                    multi={true}
                                                    maxHeight={130}
                                                    onChange={this.resetNotification}
                                                    placeholder={'Select Notification(s)'}
                                                    value={this.state.user.userNotificationReportsMapping}
                                                    options={this.state.notifications}>
                                                </VirtualizedSelect>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <label>Select Login Identity</label>
                                                <VirtualizedSelect fluid
                                                    autosize={false}
                                                    multi={false}
                                                    maxHeight={130}
                                                    onChange={this.resetTemplate}
                                                    placeholder={'Select Identity'}
                                                    value={this.state.user.usrLoginProvider}
                                                    options={this.state.loginIdentityManagerByUser.map(template => ({
                                                        key: template.templateId,
                                                        value: template.templateId,
                                                        label: template.templateName
                                                    }))}>
                                                </VirtualizedSelect>
                                            </Form.Field>
                                        </Form.Group>
                                    </Segment>
                                </Segment.Group>
                                <Form.Group>
                                    <Form.Field width={16}>
                                        <Button.Group width={2} className="small right floated">
                                            <Button onClick={this.reset}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit} >{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default AddUser;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/AddUser.js